
<!--  -->
<template>
  <div class="comContent contentInner">
    <div class="titleInner">
      <MyTabs class="search" :tabi="tabsIndex" keyname="val" :tabs="tabsData" @change="tabChange" />
      <div class="title">
        <el-form ref="formTool" :model="formTool" :inline="true">
          <span v-if="expanded">
            <el-form-item prop="orderCode" style="margin-bottom: 0px !important;">
              <el-input v-model="formTool.orderCode" clearable placeholder="请输入订单编号" size="small" />
            </el-form-item>
            <el-form-item prop="code" style="margin-bottom: 0px !important;">
              <el-input v-model="formTool.code" clearable placeholder="请输入售后单号" size="small" />
            </el-form-item>
            <el-form-item prop="shopName" style="margin-bottom: 0px !important;">
              <el-input v-model="formTool.shopName" clearable placeholder="请输入申请人" size="small" />
            </el-form-item>
          </span>
          <span v-if="!expanded">
            <el-form-item prop="code" style="margin-bottom: 0px !important;">
              <el-input v-model="formTool.code" clearable placeholder="售后单号" size="small" style="width: 300px;" />
            </el-form-item>
          </span>
          <el-form-item>

            <MyButton type="primary" text="查询" @click="goSearch" />
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="reset()">重置</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="text" size="small" @click="handleExpand()">
              {{ expanded ? "收起" : "展开"
              }}<i :class="{
    'el-icon-arrow-up': expanded,
    'el-icon-arrow-down': !expanded,
    'el-icon--right': true,
  }"></i>
            </el-button>
          </el-form-item> -->

        </el-form>
      </div>

    </div>
    <div class="center">
      <MyTable :table-data="tableData" :index="index" :selection="selection" :page="page" :operation="operation"
        :table-option.sync="tableOption" @page-change="getcheckList" @handleSelectionChange="currentChange">
        <!-- <template slot="image" slot-scope="scope">
          <el-image :src="scope.row.image" style="width: 80px; height: 80px" />
        </template> -->
        <!-- <template slot="status"
                  slot-scope="scope">
          <MyTypes :type="scope.row.status" />
        </template>
        <template slot="address"
                  slot-scope="scope">
          <p>{{ scope.row.provinceName + scope.row.cityName + scope.row.areaName + scope.row.address }}</p>
        </template> -->
        <template slot="caozuo" slot-scope="scope">
          <el-link :underline="false" type="primary" @click="handleOpen(scope.row)">查看详情</el-link>
          <!-- <el-link :underline="false" style="margin-left:10px" type="primary" @click="agree(scope.row)">同意售后</el-link>
          <el-link :underline="false" style="margin-left:10px" type="primary" @click="reject(scope.row)">驳回售后</el-link> -->
        </template>
      </MyTable>
    </div>
    <el-dialog title="驳回原因" :visible.sync="rejectDialogShow" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
        <el-form-item label="驳回原因" prop="remark">
          <el-input v-model="ruleForm.remark" clear size="small" style="width: 190px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="submitForm('ruleForm')">确认</el-button>
          <el-button size="small" @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="资质相关售后" :visible.sync="dialogVisible" width="848px" :before-close="handleClose">
      <div class="mainContent">
        <el-scrollbar wrap-style="overflow-x:hidden;">
          <div class="dialogTitle">企业相关资质</div>
          <div class="el-upload__tip">附件不能超过10M，最多上传10个，文件格式PDF、JPG、PNG</div>
          <div class="typeView">
            <div v-for="(item, index) in companyTypes" :key="index" class="typeCell">
              <div class="typeCheck typeSelect" @click="didClickType(index)">
                <span>{{ item.name }}</span>
                <img :src="skucheck" alt="" class="checkImage">
              </div>
              <div class="uploadView">
                <el-upload class="upload-demo" :action="''" :accept="'.jpg,.jpeg,.pdf,.PDF,.JPG,.PNG,.png'" multiple
                  :limit="3" :file-list="item.image ? item.image : []" :on-preview="preview">
                  <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                </el-upload>
              </div>
            </div>
          </div>
          <div class="dialogTitle" style="margin-top: 24px;">商品相关资质</div>
          <div class="goodsView">
            <div v-for="(item, index) in goodsTypes" :key="index" class="goodsItem">
              <img :src="item.goodsImage || defaultImage" alt="" class="goodsImage">
              <div class="column goodsInnerView">
                <div class="goodsName">
                  {{ item.goodsName }}
                </div>
                <div class="goodsAfterSaleType" v-if="item.typeDetail">
                  <el-checkbox-group size="small" v-model="item.check" disabled>
                    <el-checkbox label="1">药检报告</el-checkbox>
                    <el-checkbox label="2">首营资料</el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
              <div class="uploadView">
                <el-upload class="upload-demo" :action="''" :accept="'.jpg,.jpeg,.pdf,.PDF,.JPG,.PNG,.png'" multiple
                  :limit="3" :file-list="item.image ? item.image : []" :on-preview="preview">
                  <!-- <div slot=" tip"
                  class="el-upload__tip">只能上传jpg/png文件，且不超过500kb
            </div> -->
                </el-upload>
              </div>
            </div>
          </div>
          <div class="dialogTitle" style="margin-top: 24px;">其他</div>
          <div class="typeView">
            <div v-for="(item, index) in  otherTypes" :key="index" class="typeCell">
              <div class="typeCheck typeSelect">
                <span>其他</span>
                <img :src="skucheck" alt="" class="checkImage">
              </div>
              <div class="uploadView">
                <el-upload class="upload-demo" :action="''" :accept="'.jpg,.jpeg,.pdf,.PDF,.JPG,.PNG,.png'" multiple
                  :limit="3" :file-list="item.image ? item.image : []" :on-preview="preview">
                  <!-- <div slot=" tip"
              class="el-upload__tip">只能上传jpg/png文件，且不超过500kb
        </div> -->
                </el-upload>
              </div>
            </div>
            <div class="remarkView">
              <div class="remarkInfo">具体说明（有其他证件资质需求请说明）</div>
              <el-input :disabled="true" v-model="remark" :rows="3" type="textarea" placeholder="请输入" />
            </div>
          </div>
          <div class="dialogTitle" style="margin-top: 24px;">协商历史</div>
          <div class="hisView" v-for="(item, index) in orderConsultHistoryList" :key="index">
            <div class="column">
              <div class="shopName">{{ item.consultPerson || '' }}</div>
              <div class="hisInfo">{{ item.consultResult || '' }}</div>
            </div>
            <div class="time">{{ item.consultTime || '' }}</div>
          </div>
        </el-scrollbar>

      </div>
      <template slot="footer">
        <div style="display: flex;align-items: center;">
          <div style="margin-left: auto;"></div>
          <el-button @click="dialogVisible = false" size="small">返 回</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog :visible.sync="pdfDialog" width="848px" title="详情">
      <iframe v-if="pdfStr == 'pdf' || pdfStr == 'PDF'" :src="pdfUrl" style="width: 100%; height: 100%;"
        frameborder="0"></iframe>
      <img v-else :src="pdfUrl" frameborder="0"></img>
    </el-dialog>

    <AfterInvoice ref="AfterInvoice"></AfterInvoice>
  </div>
</template>

<script>
import AfterInvoice from './afterInvoice.vue'
import defaultImage from '/public/img/default.png'
import skucheck from '@/assets/zz/selected-icon.png'
import MyButton from '@/components/myButton'
import MyTable from '@/components/myTable'
import MyTabs from '@/components/myTabs'
import MyTypes from '@/components/myTypes'
import ImgUpload from '@/components/imgUpload'
import { auditTypes } from '@/utils/enumeration'
import { aftersalePlatformPage, aftersalePlatformrReject, aftersalePlatformrAgree, platformList } from '@/api/auditcenter'
import { afterInvoice, getCertificationByOrderId, putCertificationByOrderId, reject } from "@/api/myQualification";
import dayjs from "dayjs";
import _ from 'lodash'

export default {
  components: { MyButton, MyTable, MyTabs, MyTypes, ImgUpload, AfterInvoice },
  data () {
    return {
      // orderDetail: {},
      pdfUrl: '',
      pdfStr: '',
      pdfDialog: false,
      defaultImage: defaultImage,
      skucheck,
      dialogVisible: false,
      remark: '',
      companyTypes: [],//店铺资质
      goodsTypes: [],//商品资质
      otherTypes: [],//其他资质
      orderConsultHistoryList: [],//协商历史
      typesArr: [{ name: '企业首营资料', value: '1', select: false }, { name: '购销合同', value: '2', select: false }],

      expanded: false,
      text: '',
      clearable: true,
      formTool: {
        code: '',
        shopName: '',
        orderCode: ''
      },
      tabsData: [
        { name: '售后', num: 0, val: 'PENDING', numhide: true },
        // { name: '同意售后', num: 0, val: 'AGREE', numhide: true },
        // { name: '驳回', num: 0, val: 'REJECT', numhide: true },
      ],
      tabsIndex: 'PENDING',
      operation: false,
      selection: false,
      index: false,
      tableData: [],
      tableOption: [
        { label: '申请人', prop: 'payShopName', minWidth: '180px' },
        // { label: '售后商户联系方式', prop: 'payeeShopPhone' }, // 这里表示自定义列 , slot: true
        { label: '售后商品', prop: 'goodsName', minWidth: '140px' },
        { label: '售后单据类型', prop: 'afterType', width: '160px' },
        { label: '申请时间', prop: 'appleTime', width: '160px' },
        { label: '订单编号', prop: 'orderId', width: '180px' },
        { label: '售后单号', prop: 'afterSaleCode', width: '180px' },
        { label: '售后商户', prop: 'payeeShopName', width: '160px' },
        { label: '商户联系方式', prop: 'payeeShopPhone', width: '160px' },
        { label: '操作', prop: 'caozuo', slot: true, width: '200' }
      ],
      page: {
        total: 10,
        current: 1,
        size: 10
      },
      rejectDialogShow: false,
      ruleForm: {
        remark: '',
        rejectImg: [],
      },
      rejectId: '',//驳回时弹窗临时记录id
      rules: {
        remark: [
          { required: true, message: '请输入驳回原因', trigger: 'blur' }

        ]
      }
    }
  },
  computed: {},
  watch: {},
  created () {
    this.getcheckList()
  },
  mounted () {

  },
  methods: {
    handleClose () {
      this.dialogVisible = false
    },
    // 点击已有的文件
    preview (file) {
      console.log(file)
      this.pdfUrl = file.url;
      this.pdfStr = (file.url).substring(file.url.length - 3)
      // console.log(this.pdfUrl)
      // console.log(this.pdfStr)
      this.pdfDialog = true;
    },
    submitForm () {
      let _this = this
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let imgListStr = ''
          if (this.ruleForm.rejectImg.length) {
            imgListStr = this.ruleForm.rejectImg.join(',')
          }
          aftersalePlatformrReject(
            {
              id: _this.rejectId,
              rejectReason: _this.ruleForm.remark,
              rejectVoucher: imgListStr
            }
          ).then(res => {
            _this.rejectDialogShow = false
            if (res.code == 0) {
              _this.$message.success('驳回已通过')
              _this.goSearch()
            } else {
              _this.$message.error('驳回失败')
            }
          })
        }
      })
    },
    resetForm () {
      this.ruleForm.remark = ''
      this.ruleForm.rejectImg = []
      this.rejectDialogShow = false
    },
    tabChange (i) {
      // console.log('i:' + i)
      this.tabsIndex = i
      this.page.current = 1
      this.getcheckList()
    },
    getcheckList () {
      const { current, size } = this.page
      const params = {
        current,
        size,
        // status: this.tabsIndex,
        code: this.formTool.code
        // ...this.formTool
      }
      platformList(params).then(res => {
        if (res) {
          const { records, total } = res
          this.page.total = total
          // this.tabsData[0].num = res.data.pendingQty
          // records.forEach(item => {
          //   item.status = auditTypes(item.status)
          // })
          this.tableData = records
          // if (this.tabsIndex == '0') {
          //   this.tabsData[0].num = total
          // }
        }
      })
    },
    reset () {
      // this.formTool.storeName = ''
      this.$refs.formTool.resetFields()
      this.page.current = 1
      this.getcheckList()
    },
    // 查看详情
    editDetail (row) {
      this.$router.push({ path: '/audit/auditcenter-salesDetail', query: { afterSaleId: row.id } })
    },
    // 同意
    agree (row) {
      aftersalePlatformrAgree(
        {
          id: row.id
        }
      ).then(res => {
        if (res.code == 0) {
          this.$message.success('审核已通过')
          this.goSearch()
        } else {
          this.$message.error('审核失败')
        }
      })
    },
    // 驳回 
    reject (row) {
      this.rejectId = row.id
      this.rejectDialogShow = true

    },
    currentChange (val) {
      console.log('current', val)
    },
    goSearch () {
      const { code, orderCode, shopName } = this.formTool
      this.page.current = 1
      this.getcheckList()
    },
    handleExpand () {
      this.expanded = !this.expanded;
    },
    // pageChange(val) {
    //   console.log('page', val)
    // },
    // handleSelectionChange(val) {
    //   console.log(val)
    // }
    // 查看详情
    async handleOpen (row) {
      if (row.afterType == '发票售后') {
        // this.orderDetail = row
        this.$refs.AfterInvoice.init(row)
      } else if (row.afterType == '资质售后') {
        await this.getDetail(row)
        this.dialogVisible = true
      }

    },
    // 获取详情
    async getDetail (row) {
      for (let index = -3; index < 0; index++) {
        const last = dayjs().add(index, "years").format('YYYY')
        this.typesArr.push({ name: last + '年度报告', value: index + 6, select: false })
      }
      let params = { orderId: row.orderId }
      const r = await getCertificationByOrderId(params)
      if (r) {
        const { companyTypes, goodsTypes, otherTypes, orderConsultHistoryList, remark } = r
        if (companyTypes && companyTypes.length) {
          let arr = _.cloneDeep(companyTypes)
          arr.forEach(e => {
            this.typesArr.forEach((l) => {
              if (e.typeDetail == l.value) {
                e['name'] = l.name
              }
            })
            let imageArr = e.image ? _.cloneDeep(e.image).split(',') : []
            let newArr = []
            if (imageArr.length > 0) {
              imageArr.forEach(el => {
                let obj = {
                  name: el.substring(57),
                  url: el
                }
                newArr.push(obj)
              })
            }
            e.image = newArr
          });
          this.companyTypes = arr
        }
        if (goodsTypes && goodsTypes.length) {
          let arr = _.cloneDeep(goodsTypes)
          arr.forEach((e) => {
            e['check'] = e.typeDetail ? (e.typeDetail).split(',') : []
            e['images'] = e.image ? (e.image).split(',') : []
            let imageArr = e.image ? _.cloneDeep(e.image).split(',') : []
            let newArr = []
            if (imageArr.length > 0) {
              imageArr.forEach(el => {
                let obj = {
                  name: el.substring(57),
                  url: el
                }
                newArr.push(obj)
              })
            }
            e.image = newArr
          })
          this.goodsTypes = arr
        }
        if (otherTypes && otherTypes.length > 0) {
          otherTypes.forEach(item => {
            let imageArr = item.image ? _.cloneDeep(item.image).split(',') : []
            let newArr = []
            if (imageArr.length > 0) {
              imageArr.forEach(el => {
                let obj = {
                  name: el.substring(57),
                  url: el
                }
                newArr.push(obj)
              })
            }
            item.image = newArr
          })
        }
        if (otherTypes && otherTypes.length) {
          this.otherTypes = otherTypes
        }
        if (orderConsultHistoryList && orderConsultHistoryList.length) {
          this.orderConsultHistoryList = orderConsultHistoryList
        }
        this.remark = remark || ''
      }

    },
  }
}
</script>
<style lang='scss' scoped>
::v-deep .el-dialog__body {
  height: 600px;
  overflow: auto;
}

::v-deep .upload-demo {
  width: 150px;
}

::v-deep .el-upload--text {
  display: none;
}

.comContent {
  .titleInner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    padding: 0px 24px;

    .title {
      display: flex;
      justify-content: right;
      align-items: center;

      .el-form--inline>.el-form-item {
        margin-bottom: 0px !important;
      }
    }

    .search {
      align-items: center;
    }
  }
}

.contentInner {
  padding: 0px;
}

.center {
  margin-top: 16px;
  padding: 0px 24px;
  height: calc(100% - 136px);
}

.mainContent {
  width: 800px;
}

.dialogTitle {
  font-size: 14px;
  line-height: 16px;
  padding-left: 10px;
  position: relative;
  text-align: left;
  color: #595959;
  margin-bottom: 12px;

  &:before {
    content: '';
    display: inline-block;
    width: 3px;
    height: 16px;
    background-color: #f5222d;
    position: absolute;
    top: 0;
    left: 0;
  }
}

.typeView {
  display: flex;
  flex-direction: column;
  cursor: pointer;

  .typeCell {
    display: flex;
    align-items: center;
    margin: 5px 0px;

    .typeCheck {
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      color: #262626;
      font-size: 12px;
      margin-right: 5px;
      position: relative;
      min-width: 88px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 36px;

      .checkImage {
        position: absolute;
        bottom: 0;
        right: 0;
        height: 15px;
        width: 15px;
      }
    }

    .typeSelect {
      border: 1px solid #f5222d;
    }


  }
}

.uploadView {
  display: flex;
  align-items: center;
  margin-left: 10px;

  .uploadImg {
    width: 86px;
    height: 86px;
    background: #ffffff;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
    margin-left: 8px;

    .icon {
      position: relative;
      width: 100%;
      height: 100%;
    }

    .preview {
      position: absolute;
      visibility: hidden;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0.5;
      background: #000000;
      display: flex;
      align-items: center;
      justify-content: center;

      .btn-icon {
        width: 16px;
        height: 16px;
        cursor: pointer;

        &+.btn-icon {
          margin-left: 8px;
        }
      }
    }

    &:hover {
      .preview {
        visibility: visible;
      }
    }

    &.add-pic {
      border: 1px dashed #d9d9d9;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      .image-wrap {
        border: 1px dashed #d9d9d9;
        width: 20px;
        height: 20px;

        &>* {
          width: 100%;
          height: 100%;
        }
      }

      .text {
        font-size: 14px;
        font-weight: 400;
        color: #595959;
        margin-top: 8px;
      }
    }

  }
}

.goodsView {
  display: flex;
  flex-wrap: wrap;

  .goodsItem {
    width: 100%;
    min-height: 80px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .goodsImage {
      height: 60px;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      overflow: hidden;
      padding: 4px;
    }

    .goodsInnerView {
      width: 200px;
    }

    .column {
      display: flex;
      flex-direction: column;
      margin-left: 12px;

      .goodsName {
        font-size: 14px;
        color: #262626;
      }

      .goodsAfterSaleType {
        display: flex;
        align-items: center;
        margin-top: 5px;
      }
    }

  }

}

.hisView {
  display: flex;
  border-bottom: 1px solid #d9d9d9;
  padding: 12px 0px;
  justify-content: space-between;

  .shopName {
    font-size: 14px;
    color: #262626;
    font-weight: 600;
  }

  .hisInfo {
    font-size: 12px;
    color: #595959;
    margin-top: 12px;
  }
}

.remarkView {
  padding: 5px 0px;

  .remarkInfo {
    line-height: 16px;
    text-align: left;
    color: #595959;
    margin-bottom: 12px;
  }
}
</style>
